import React from 'react'

const Error = () => {
  return (
    <h1>エラーが発生しました。</h1>
  )
}

export default Error